/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import * as t from "io-ts";

/**
 * Amount for payments, in euro cents
 */

export type AmountEuroCents = t.TypeOf<typeof AmountEuroCents>;
export const AmountEuroCents = t.union([
  WithinRangeInteger<0, 99999999999, IWithinRangeIntegerTag<0, 99999999999>>(
    0,
    99999999999
  ),
  t.literal(99999999999)
]);
